import {DataFetcher} from '@aboutyou/data-fetcher';
import {SkeletonBlock} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {useGenderSwitchSection} from '../hooks/useGetHeaderBulkSection';
import {GenderSwitchView} from './GenderSwitchView';

export const GenderSwitch: React.FC<{
  className?: string;
}> = props => (
  <DataFetcher
    request={useGenderSwitchSection()}
    Loading={Skeleton}
    View={GenderSwitchView}
    viewProps={props}
    Error={() => null}
  />
);

const Skeleton = () => {
  return (
    <Wrapper>
      <SkeletonBlock $width="180px" $height="20px" />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin-top: 16px;
`;
